import { useEffect } from 'react';
import './style.css';

function ADSENSE({ adClient, adSlot, style }) {
    useEffect(() => {
        const adsbygoogleScript = document.createElement('script');
        adsbygoogleScript.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
        adsbygoogleScript.async = true;
        document.body.appendChild(adsbygoogleScript);

        adsbygoogleScript.onload = () => {
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            } catch (e) {
                console.error("Erro ao inicializar o Google AdSense:", e);
            }
        };

        return () => {
            document.body.removeChild(adsbygoogleScript);
        };
    }, []);

    return (
        <div>
            <ins
                className="adsbygoogle"
                style={style || { display: 'block' }}
                data-ad-client={adClient}
                data-ad-slot={adSlot}
                data-ad-format="auto"
            ></ins>
        </div>
    );
}

export default ADSENSE;